import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { GISMap } from "@/components/GISMap";
import { BrandWordmark, BrandMark } from "@/components/BrandMark";
import { ArrowLeft } from "lucide-react";

export const PublicMap = () => {
  const parcelsQ = useQuery({ queryKey: ["pub-parcels"], queryFn: async () => (await api.get("/public/map/parcels")).data });
  const mineQ = useQuery({ queryKey: ["pub-mining"], queryFn: async () => (await api.get("/public/map/mineral-rights")).data });

  return (
    <div className="min-h-screen p-6 lg:p-12 space-y-5">
      <div className="flex items-center justify-between">
        <BrandMark size={140} />
        <Link to="/portal" className="cad-btn-outline px-3 py-1.5 rounded-sm text-[12px] inline-flex items-center gap-1.5"><ArrowLeft size={12}/> Portal</Link>
      </div>
      <div>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#C99A2E]">National Cadastral Map</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1">Public GIS Explorer</h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">Public-safe layers — parcel and mineral-right polygons only.</div>
      </div>
      <GISMap parcels={parcelsQ.data || []} minerals={mineQ.data || []} height={620} />
    </div>
  );
};
